module.exports = __webpack_public_path__ + "img/colorBox3.7d9e447a.jpg";